import React from 'react'
import './footer.css'

class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
                <div className="footer-twt">Powered by TWT STUDIO &copy; 2000-2020</div>
            </div>
        );
    }
}

export default Footer;